import React, {Fragment, useEffect} from 'react';
import {Link, useParams} from 'react-router-dom';
import numeral from 'numeral';
import {useSelector} from "react-redux";
import config from "bootstrap/js/src/util/config";

const Sidebar = () => {

    const { labels, config: {option, sideBar, logoBar}, label } = useSelector((state) => state.mailBox)

    useEffect(() => {
        document.querySelector("link[rel*='icon']").href = config.favicon;
    }, [option]);


    let { slug } = useParams();
    slug = (typeof slug === 'undefined') ? label : slug;

    return (
        <div className="sidebar" style={{backgroundColor: sideBar.bgColor}}>
            <div className="sidebar-header">
                <Link to="/" className="sidebar-logo" style={{backgroundColor: logoBar.bgColor, color: logoBar.color}}>
                    {  option.logo.length > 0 &&
                        <img src={option.logo} alt={option.short_title} className="img-fluid" title={`${option.site_title} - ${option.short_title}`} />
                    }
                    <Fragment>
                        <div><small>{option.site_title}</small></div>
                        <strong className="d-block text-center" style={{color: logoBar.color}}>{option.short_title}</strong>
                    </Fragment>
                </Link>
            </div>
            <div className="sidebar-body">
                <label className="sidebar-label" style={{color: sideBar.headingColor}}>Mailboxes</label>
                <nav className="nav flex-column mb-5">
                    {labels?.directory?.map((item, i) => (
                        <Link key={item.id} to={`/${item.slug}`}
                              className={`nav-link ${(item.slug === slug || (labels.tabs.find((l) => l.slug === slug) && i === 0) ? `active` : '')}`}
                              style={{color: sideBar.color}}
                        >
                            <i className={item?.icon}></i>
                            <span>{item.label}</span>
                            {(item.total > 0 ? <small>{numeral(item.total).format('0,0')}</small> : '')}
                        </Link>
                    ))}
                </nav>

                <label className="sidebar-label" style={{color: sideBar.headingColor}}>Labels</label>
                <nav className="nav flex-column mb-5">
                    {labels?.labels?.map((item) => (
                        <Link key={item.id} to={`/${item.slug}`} className="nav-link" style={{color: sideBar.color}}>
                            <i className="ri-price-tag-line" classNName={item?.icon}></i> <span>{item.label}</span>
                        </Link>
                    ))}
                </nav>
            </div>
        </div>
    );
};

export default Sidebar;